import { render } from "./ComposeEmail.vue?vue&type=template&id=28e11ace&scoped=true"
import script from "./ComposeEmail.vue?vue&type=script&lang=js"
export * from "./ComposeEmail.vue?vue&type=script&lang=js"

import "./ComposeEmail.vue?vue&type=style&index=0&id=28e11ace&scoped=true&lang=css"
import "./ComposeEmail.vue?vue&type=style&index=1&id=28e11ace&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e11ace"]])

export default __exports__